<template>
  <MenuPopper :trigger-label="$t('help')" trigger-classes="hover:text-primary hover:underline">
    <template #menu>
      <div class="w-full flex flex-col items-start gap-y-1">
        <RouterLink
          :to="item.path"
          :key="key"
          v-for="(item, key) in helpItems"
          v-bind="item"
          class="w-full text-start px-3 py-1.5 text-sm text-primary hover:text-primary-700 hover:bg-gray-200"
        >
          {{ item.label }}
        </RouterLink>
      </div>
    </template>
  </MenuPopper>
</template>

<script setup>
import MenuPopper from '@/components/Buttons/MenuPopper.vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const i18n = useI18n()

const helpItems = computed(() => {
  return [
    {
      path: '/customer-survey',
      label: i18n.t('Questiner')
    },
    {
      path: '/faq',
      label: i18n.t('FAQMenu')
    },
    {
      path: '/instructions',
      label: i18n.t('instructionsMenu')
    },
    {
      path: '/help/browse-services',
      label: i18n.t('smartservice')
    }
  ]
})
</script>

<style lang="scss" scoped></style>
